import { ChannelAvatar, Flex, Text } from '@buffer-mono/popcorn'
import { isChannelType } from '~publish/helpers/channels'

import styles from './ChannelSelector.module.css'

import type { JSX } from 'react'

export interface GroupTooltipChannel {
  id: string
  name: string
  service: string
  avatar?: string | null
}

export interface GroupTooltipContentProps {
  name: string
  channels: GroupTooltipChannel[]
}

/**
 * Tooltip content listing the channels in a group, with the group name as a
 * header. Shared by the channel group chips in the dropdown and the channel
 * group suggestions.
 */
export function GroupTooltipContent({
  name,
  channels,
}: GroupTooltipContentProps): JSX.Element {
  return (
    <Flex direction="column" gap="xs">
      <Text size="sm" weight="medium" translate="no">
        {name}
      </Text>
      {channels.map((channel) => (
        <Flex direction="row" align="center" gap="xs" key={channel.id}>
          {isChannelType(channel.service) && (
            <ChannelAvatar
              size="xsmall"
              channel={channel.service}
              src={channel.avatar ?? undefined}
              alt=""
              className={styles.tooltipAvatar}
            />
          )}
          <Text size="sm" translate="no">
            {channel.name}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
